export default function BigBlueSection({ children }) {
  return (
    <section className="bg-blue-gradient">
      <div className="max-w-screen-xl mx-auto py-10 px-5">{children}</div>
    </section>
  )
}
